<template>
  <div class="section">
    <h3 class="mt-4">
      ストーリー
      <small class="text-muted">
        <font-awesome-icon icon="edit" @click="openModal()" />
      </small>
    </h3>
    <div class="row">
      <div class="col-12">
        <MarkdownView :text="value" />
      </div>
    </div>
    <b-modal :id="uid('modal')"
             centered size="xl"
             title="ストーリー"
             @shown="modalShown"
             @ok="modalSave">
      <form @submit.stop.prevent="modalSubmit">
        <div class="form-group">
          <textarea :id="uid('modal-text')"
                    class="form-control"
                    ref="modalText"
                    rows="30"
                    v-model="text"
                    @keypress="modalKeyPress">
          </textarea>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import MarkdownView from '@/components/MarkdownView.vue'

export default {
  name: 'StoryView',

  components: {
    MarkdownView
  },

  data(){
    return {
      text: ''
    }
  },

  methods: {
    emitter(value){
      this.$emit('input', value)
    },

    uid(prefix){
      return prefix + '-' + this._uid
    },

    openModal(){
      this.text = this.value
      this.$bvModal.show(this.uid('modal'))
    },

    modalShown(){
      this.$refs.modalText.focus()
    },

    modalKeyPress(e){
      if(e.ctrlKey && e.keyCode == 10){ this.modalSubmit() }
    },

    modalSubmit(){
      this.modalSave()
      this.$bvModal.hide(this.uid('modal'))
    },

    modalSave(){
      this.emitter(this.text)
    }
  },

  props: {
    value: {
      required: false,
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
